//css-------------------
import "@/css/home/award.scss";




//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";


//npm lib  
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
        });
    },
    methods: {
        ...baseMethods,
    },
}).mount("#app");
